








import { Vue, Component, Prop } from 'vue-property-decorator'
import { convertPxToVw } from '../utils'

const heightMap = {
  suspend: 75,
}
@Component({})
export default class CompWrap extends Vue {
  @Prop() data: any
  @Prop() text: string

  dragStyle: any = {}

  winHeight: number = 700
  winWidth: number = 375
  showEl: boolean = false
  mobileEl: any = null
  isMove: boolean = false
  clientX: number = 0
  clientY: number = 0

  offsetLeft: number = 0
  offsetTop: number = 0
  get compHeight() {
    return '75px'
  }

  // get dragStyle() {
  //   let top = parseInt(this.data.top)
  //   let left = parseInt(this.data.left)
  //   if (top + 75 > this.winHeight) {
  //     top = this.winHeight - 75
  //   }
  //   if (left + 75 > this.winWidth) {
  //     left = this.winWidth - 75
  //   }

  //   return {
  //     width: this.data.width + 'px' || '75px',
  //     height: this.data.height + 'px' || '75px',
  //     top: top ? top + 'px' : 'auto',
  //     left: left ? left + 'px' : 'auto',
  //     bottom: this.data.bottom || 'auto',
  //     right: this.data.right || 'auto',
  //   }
  // }

  mounted() {
    this.showEl = true
    this.winHeight =
      document.documentElement.clientHeight || window.screen.height
    this.winWidth = document.documentElement.clientWidth || window.screen.width
    this.updatePosation()
  }

  updatePosation() {
    let middleNum = (this.winWidth - (this.data.width || 75)) / 2
    let top: any = parseInt(this.data.top)
    let bottom
    if (top + 75 > this.winHeight) {
      top = 'auto'
      bottom = '0px'
    } else {
      top = this.data.top
      bottom = 'auto'
    }

    // let left, right
    // if (parseInt(this.data.left, 10) < middleNum) {
    //   left = 18 + 'px'
    //   right = 'auto'
    // }
    // if (parseInt(this.data.left, 10) >= middleNum) {
    //   right = 18 + 'px'
    //   left = 'auto'
    // }
    this.dragStyle = {
      width: this.data.width + 'px' || '75px',
      height: this.data.height + 'px' || '75px',
      top: `${convertPxToVw(top)}vw`,
      bottom: `${convertPxToVw(bottom)}vw`,
      left: 'auto',
      right: `${convertPxToVw(this.data.right)}vw`,
    }
    if (this.data.type === 'textCarousel') {
      this.dragStyle.width = 0
      this.dragStyle.height = 0
      this.dragStyle.right = `${convertPxToVw(18)}vw`
    }
  }
}
